import * as React from 'react';
import styled from 'styled-components';

const OuchComponent = (props: any) => (
    <div className={ props.className }>
        <img src={"/images/ouch.png"}/>
        <h1><em>Autsch!</em> Da ist etwas schiefgelaufen!</h1>
    </div>
);

export default styled(OuchComponent)`
  display: flex;
 
  flex: 1;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  
  h1 {
    color: white;
    text-align: center;
   
    font-family: "DIN Next";
    
    em {
      font-family: "Px Grotesk Bold";
      font-style: normal;
      font-weight: bold;
      text-transform: uppercase;
    }
  }
  
  img {
    width: 600px;
  }
  
  width: 100%;
`;



// WEBPACK FOOTER //
// ./src/components/OuchComponent.tsx